/* OsLinkEnableRenderer.js */

"use strict";

// const _ = require("lodash");

class IotOsLinkEnableRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("oslink-enable-column");
        this._rootElem.component = this._model;
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("OsLinkEnable", (this._onOsLinkEnable = this._onOsLinkEnable.bind(this)));
    }

    _unregisterListeners() {
        if (this._model) {
            this._model.removeAllListeners("OsLinkEnable");
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            const val = this._model.getEnableValue();
            this._enableCheckBox = this._generateCheckbox([], "", val);
            this._rootElem.innerHTML = "";
            this._rootElem.appendChild(this._enableCheckBox);

            // Ensure DOM is updated before setting disabled class
            requestAnimationFrame(() => {
                this._setDisabledClassForRow(val);
                resolve();
            });
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onOsLinkEnable(newVal) {
        this._setOsLinkEnable(newVal);
    }

    _onCheckBoxClicked(e) {
        const elem = e.target,
            // type = elem.getAttribute('check-type'),
            val = elem.checked;
        this._setDisabledClassForRow(val);
        this._enableChanged(val);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setOsLinkEnable(newVal) {
        this._checkBox.checked = newVal;
        this._setDisabledClassForRow(newVal);
    }

    _setDisabledClassForRow(newVal) {
        const unlockedGridRow = this._rootElem.closest("unlocked-grid-row");
        if (unlockedGridRow) {
            unlockedGridRow.classList.toggle("disabled", !newVal);
        }
    }

    _generateCheckbox(textArr, type, value = false) {
        const parentContainer = document.createElement("label"),
            sliderDiv = document.createElement("div");
        this._checkBox = document.createElement("input");

        parentContainer.classList.add("switch");
        this._checkBox.setAttribute("type", "checkbox");
        this._checkBox.setAttribute("check-type", type);
        this._checkBox.checked = value;

        this._checkBox.addEventListener(
            "click",
            (this._onCheckBoxClicked = this._onCheckBoxClicked.bind(this))
        );

        parentContainer.appendChild(this._checkBox);

        textArr.forEach((text) => {
            const textForCheckBox = document.createElement("span");
            textForCheckBox.innerText = text;
            sliderDiv.appendChild(textForCheckBox);
        });

        sliderDiv.classList.add("slider", "round");
        parentContainer.appendChild(sliderDiv);

        return parentContainer;
    }

    _enableChanged(val) {
        // Set the value to entity
        // Save the entity
        this._model.enableLink(val);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = IotOsLinkEnableRenderer;
